import { useEffect, useState } from "react";
import { callAPIForQuery } from "../../../utilities/service";
import { cloneDeep } from "lodash";
import { Loader } from "../../common/Loader";
import './index.scss'
import { useNavigate } from "react-router-dom";
import { useCustomContext } from "../../../state/CustomContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
export const PatientView = () => {
    const [appointments, setAppointments] = useState([])
    const [loading, setLoading] = useState(false);
    const context = useCustomContext();
    const { state } = context;
    const navigate = useNavigate();
    const [input, setInput] = useState({
        from_date: moment().format('YYYY-MM-DD'), //'2025-03-08',
        to_date: moment().format('YYYY-MM-DD')
    })
    useEffect(() => {
        getPatient();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    const updateInputInfo = (key: string, value: string) => {
        const inputCopy: any = cloneDeep(input);
        inputCopy[key] = value;
        setInput(inputCopy);
    }
    const getPatient = async () => {
        let xmlString = '<profile>';
        xmlString += `<from_date>${input.from_date}</from_date>`;
        xmlString += `<to_date>${input.to_date}</to_date>`
        xmlString += '</profile>'
        setLoading(true)
        const result = await callAPIForQuery({ input: xmlString, type: 'GetAppointmentsByDate' }, 'post')
        setLoading(false)
        if (!result.error) {
            setAppointments(result[0])
        }
    }
    if (loading) {
        return <Loader />
    }
    return <div>
        <div className="row">
            <div className="col-lg-2">
                <div className="form-option">
                    <div className="field-title">From Date</div>
                    <input type="date" className="form-control" value={input.from_date || ''} onChange={(event: any) => {
                        updateInputInfo("from_date", event.target.value)
                    }} />
                </div>
            </div>
            <div className="col-lg-2">
                <div className="form-option">
                    <div className="field-title">To Date</div>
                    <input type="date" className="form-control" value={input.to_date || ''} onChange={(event: any) => {
                        updateInputInfo("to_date", event.target.value)
                    }} />
                </div>
            </div>
            <div className="col-lg-2">
                <div className="form-option">
                    <div className="field-title hide">To Date</div>
                    <input type="button" value="Search" onClick={getPatient} />
                </div>
            </div>

        </div>
        <div className="appointment-grid">
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Phone No</th>
                        <th>Gender</th>
                        <th>Age</th>
                        {state.role_id === 2 && (<th>Status</th>)}
                        <th>Created Date</th>
                        {state.role_id === 2 && (<th>Ambulance Track</th>)}
                        {[3, 4].includes(state.role_id) && (<th>Medical Info</th>)}
                    </tr>
                </thead>
                <tbody>
                    {appointments.map((appointment: any) => (
                        <tr key={appointment.id}>
                            <td>{appointment.id}</td>
                            <td>{appointment.first_name}</td>
                            <td>{appointment.last_name}</td>
                            <td>{appointment.phone_no}</td>
                            <td>{appointment.gender_name}</td>
                            <td>{appointment.age}</td>
                            {state.role_id === 2 && (<td>{appointment.next_step_name || 'Completed'}</td>)}
                            <td>{moment(appointment.created_date).format("DD MMM YYYY HH:MM")}</td>
                            {state.role_id === 2 && (<td>  <FontAwesomeIcon icon={faEdit} style={{ cursor: "pointer" }} onClick={() => {
                                navigate(`/ambulance-status-track?appointment_id=${appointment.id}`)
                            }} /> </td>)}
                            {[3, 4].includes(state.role_id) && (<td>
                                <FontAwesomeIcon icon={faEdit} style={{ cursor: "pointer" }} onClick={() => {
                                    navigate(`/paramedical-info?appointment_id=${window.btoa(appointment.id)}`)
                                }} />
                            </td>)}

                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
}